import './ToolHistoryTabSkeleton.scss';

/** Skeleton del tab de historial mientras carga */
export const ToolHistoryTabSkeleton = () => {
  const skeletonSteps = [
    { hasEvents: true, eventsCount: 2 },
    { hasEvents: false, eventsCount: 0 },
    { hasEvents: true, eventsCount: 1 },
    { hasEvents: false, eventsCount: 0 }
  ];

  return (
    <div className="toolHistoryTabSkeleton">
      {skeletonSteps.map((step, index) => (
        <div key={index} className="skeletonStep">
          <div className="skeletonLine" />
          <div className="skeletonHeader">
            <div className="skeletonIcon animationLoader" />
            <div className="skeletonTitle animationLoader" />
          </div>
          {step.hasEvents && (
            <div className="skeletonEvents">
              {Array(step.eventsCount)
                .fill(null)
                .map((_, eventIndex) => (
                  <div key={eventIndex} className="skeletonEvent">
                    <div className="skeletonEventDot animationLoader" />
                    <div className="skeletonEventTitle animationLoader" />
                  </div>
                ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

